// extracted by mini-css-extract-plugin
export var categories = "index-module--categories--49de1";
export var isActive = "index-module--isActive--49452";